export const currencyType = [
    "USD",
    "CAD"
];